import React from 'react';
import PropTypes from 'prop-types';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import { searchProjects } from 'bundles/apex/deals/connect_to_listing/api';

export default function ProjectSelector({ deal, project, onChange }) {
  return (
    <ManagedFormGroup
      getOptionValue={project => project.id}
      isClearable
      label="Search Marketing Properties"
      loadOptions={(query, callback) => searchProjects(deal, query, callback)}
      noOptionsMessage="No marketing properties found"
      placeholder="Search name or address"
      type="combobox"
      value={project}
      onValueChange={onChange}
    />
  );
}

ProjectSelector.propTypes = {
  deal: PropTypes.object,
  project: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
